import React, { useState, useMemo } from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import TitleLink from 'components/UI/TitleLink';
import Subtitle from 'components/UI/Subtitle';
import List from 'components/UI/List';
import Button from 'components/UI/Button';
import Tabs from 'components/UI/Tabs';
import ToolIcons from './components/ToolIcons';
import TileIcons from './components/TileIcons';
import { useTrans } from 'utils/localisation';
import { createPanelID, createTabID } from 'utils/tabs';

import * as styles from './TechnologiesGrid.module.scss';

export default function DesktopContent({ tabsContent, showModal }) {
  const initialTab = tabsContent[0].id;
  const tabsAriaLabel = 'Expertise Tabs';
  const t = useTrans(['common']);
  const [activeTab, setActiveTab] = useState(initialTab);
  const [opacity, setOpacity] = useState({
    '--opacity': 1,
  });

  const tabNames = useMemo(() => {
    if (tabsContent.length > 1) {
      return tabsContent.map(({ id, tabLabel }) => ({ id, tabLabel }));
    }
  }, [tabsContent]);

  return (
    <div className={styles.desktopContent}>
      {tabNames && (
        <Tabs
          className={styles.tabsRow}
          filters={tabNames}
          active={activeTab}
          setActive={setActiveTab}
          setStyles={setOpacity}
          tabsAriaLabel={tabsAriaLabel}
        />
      )}
      {tabsContent.map(
        (
          { id, title, description, listTitle, list, link, tools, tiles, button, withoutButton },
          i,
        ) => (
          <div
            key={`Desktop-${id}`}
            id={createPanelID(tabsAriaLabel, i)}
            className={styles.tab}
            style={opacity}
            role="tabpanel"
            tabIndex={0}
            aria-labelledby={createTabID(tabsAriaLabel, i)}
            hidden={activeTab !== id}
          >
            <div className={styles.tabContent}>
              <div className={styles.infoBlock}>
                {link ? (
                  <TitleLink href={link} tag="h3">
                    {title}
                  </TitleLink>
                ) : (
                  <Title tag="h3">{title}</Title>
                )}
                <Subtitle size="md">{description}</Subtitle>
                {listTitle && <p className={cn(styles.listTitle, styles.list)}>{listTitle}</p>}
                {list && (
                  <List
                    items={list}
                    className={cn(!listTitle && styles.list, !tabNames && styles.singleTabList)}
                    theme={tabNames ? 'smallMarginChecked' : null}
                    itemTag="p"
                  />
                )}
                {!withoutButton && (
                  <div className={styles.buttonRow}>
                    {button ? (
                      <Button tag="a" href={button.link}>
                        {button.name}
                      </Button>
                    ) : (
                      <Button onClick={showModal}>{t('requestServices')}</Button>
                    )}
                  </div>
                )}
              </div>
              <div className={styles.tools}>
                {tools && <ToolIcons tools={tools} />}
                {tiles && <TileIcons tiles={tiles} />}
              </div>
            </div>
          </div>
        ),
      )}
    </div>
  );
}
